// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"9ec7cb7fde448dc14be8","682":"7cb28995a30bede26750","883":"9fa2e1101d320a1f9e0c"}[chunkId] + ".js";
};